import { render, staticRenderFns } from "./patientMyList.vue?vue&type=template&id=ff14c5aa&scoped=true"
import script from "./patientMyList.vue?vue&type=script&lang=js"
export * from "./patientMyList.vue?vue&type=script&lang=js"
import style0 from "./patientMyList.vue?vue&type=style&index=0&id=ff14c5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff14c5aa",
  null
  
)

export default component.exports